import r from "./_cb.js";
import o from "./_isArrayLike.js";
import t from "./keys.js";
function e(e, f, i) {
  f = r(f, i);
  for (var m = !o(e) && t(e), s = (m || e).length, a = 0; a < s; a++) {
    var n = m ? m[a] : a;
    if (f(e[n], n, e)) return !0;
  }
  return !1;
}
export { e as default };